import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import _ from 'lodash'
import { useLocation } from 'react-router-dom'

import { Routes } from '../routes/routes'
import { Dictionary } from '../utils/types'
import { generateRoute } from '../utils/routes'

import { useAppConfig } from '.'

export type RouteGeneratorFunc = (
  to: Routes | string,
  params?: Dictionary<React.ReactText>,
  withoutTranslation?: boolean,
  query?: Dictionary<string>
) => string

export function useLinkGenerator() {
  const { i18n } = useTranslation(['routes'])
  const { availableLanguages, primaryLanguage } = useAppConfig()
  const location = useLocation()
  let locale = location.pathname.substring(1, 3).toLowerCase()
  if (!_.includes(availableLanguages, primaryLanguage)) {
    locale = primaryLanguage
  }
  const tr = i18n.getFixedT(locale, 'routes')

  const generateRouteCallback = useCallback<RouteGeneratorFunc>(
    (to, params = {}, withoutTranslation = false, query = {}) =>
      generateRoute(to, locale, tr, params, withoutTranslation, query),
    [locale, tr]
  )

  return {
    generateRoute: generateRouteCallback
  }
}
